import React from 'react';
import {
  Box,
  Divider,
  Grid,
  MenuItem,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import TextFieldContext from 'components/CustomInputsInFormikContext/TextField';
import CardWrapper from 'components/Financial/CardWrapper';
import { useFormikContext } from 'formik';
import SelectFieldContext from 'components/CustomInputsInFormikContext/Select';
import { isCpf, labelField } from 'utils';
import maskCPF from 'components/Masks/maskCPF';
import maskCNPJ from 'components/Masks/maskCNPJ';
import maskPhone from 'components/Masks/maskPhone';
import { styled } from '@mui/styles';
import DoneIcon from '@mui/icons-material/Done';
import { useDependencyInjection } from 'hooks/useDependencyInjection';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  '& .MuiToggleButtonGroup-grouped': {
    minWidth: 90,
    maxWidth: 90,
    maxHeight: 32,
    borderRadius: 16,
    fontSize: 12,
    textTransform: 'capitalize',
    '&.Mui-disabled': {
      border: 0,
    },
  },
}));

function PersonalData({ disabledFields }) {
  const { getFieldProps, setFieldValue } = useFormikContext();
  const { value: nature } = getFieldProps('nature');
  const { value: active } = getFieldProps('is_active');

  const { id } = useDependencyInjection();

  const handleActive = (e, value) => {
    if (value) {
      setFieldValue('is_active', true);
    } else if (value === false) {
      setFieldValue('is_active', false);
    }
  };

  const cpfSelected = isCpf(nature);

  return (
    <CardWrapper title="Dados Pessoais">
      <Grid item xs={12} sm={6} md={4}>
        <SelectFieldContext
          disabled={disabledFields}
          id="nature"
          name="nature"
          label={labelField('Natureza')}
          onChangeCallback={() => {
            setFieldValue('cpf_cnpj', '');
          }}
        >
          <MenuItem key={1} value="Pessoa Física">
            Pessoa Física
          </MenuItem>
          <MenuItem key={2} value="Pessoa Jurídica">
            Pessoa Jurídica
          </MenuItem>
        </SelectFieldContext>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          disabled={disabledFields}
          InputLabelProps={{
            style: { pointerEvents: 'auto' },
            shrink: disabledFields,
          }}
          InputProps={{
            inputComponent: cpfSelected ? maskCPF : maskCNPJ,
          }}
          id="cpf_cnpj"
          label={cpfSelected ? labelField('CPF') : labelField('CNPJ')}
          name="cpf_cnpj"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          disabled={disabledFields}
          inputProps={{ maxLength: 100 }}
          id="name"
          label={
            cpfSelected
              ? labelField('Nome completo')
              : labelField('Razão social')
          }
          name="name"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          disabled={disabledFields}
          id="phone"
          label={labelField('Celular')}
          name="phone"
          type="text"
          InputProps={{
            inputComponent: maskPhone,
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          disabled={disabledFields}
          label={labelField('Email')}
          type="email"
          name="email"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextFieldContext
          disabled={disabledFields}
          label={labelField('Função')}
          name="professional_qualification"
        />
      </Grid>

      {id && (
        <>
          <Grid item xs>
            <Divider flexItem />
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
              <StyledToggleButtonGroup
                size="small"
                value={active}
                exclusive
                onChange={handleActive}
                color="success"
              >
                <ToggleButton key={1} value aria-label="active-true">
                  <Box display="flex" alignItems="center" gap={0.5}>
                    {active && <DoneIcon sx={{ width: 17, height: 17 }} />}
                    Sim
                  </Box>
                </ToggleButton>
                <ToggleButton key={2} value={false} aria-label="active-false">
                  <Box display="flex" alignItems="center" gap={0.5}>
                    {!active && <DoneIcon sx={{ width: 17, height: 17 }} />}
                    Não
                  </Box>
                </ToggleButton>
              </StyledToggleButtonGroup>
              <Typography fontWeight={500}>
                Esse usuário está ativo na plataforma?
              </Typography>
            </Box>
          </Grid>
        </>
      )}
    </CardWrapper>
  );
}

export default PersonalData;
